/* eslint-disable global-require */
module.exports = ['lots.no_access.m9'];
